import { api, cheminLienArchive } from './client.js';

/**
 * Archive de la galerie — `/v1/archives` et `/v1/exports/:jeton`
 * (`docs/dev/api.md` § 12, ARTO-54). Réservé aux membres de la DIRECTION,
 * connectés, y compris d'une galerie résiliée jusqu'à sa purge.
 *
 * Télécharger ne vaut pas remise : la remise est l'accusé de réception, lié à
 * l'empreinte SHA-256 de la version téléchargée en entier par ce compte.
 */
export interface ArchivePresentee {
  readonly id: string;
  readonly galerie: {
    readonly id: string;
    readonly slug: string;
    readonly nom: string;
    readonly etat: string;
  };
  readonly origine: 'console' | 'resiliation' | 'mensuel';
  readonly final: boolean;
  readonly etat: 'pret' | 'incomplet';
  readonly pretLe: string | null;
  readonly octets: number;
  readonly sha256: string;
  readonly nomFichier: string;
  /** Fin de validité du lien de CE compte, `null` s'il n'en a pas. */
  readonly lienExpireLe: string | null;
  readonly telechargeeParMoi: boolean;
  /** Téléchargements ENTIERS de cette version par ce compte (R12). */
  readonly telechargementsParMoi: number;
  readonly accuseeParMoi: boolean;
  /** Second facteur à revérifier avant de télécharger ou d'accuser. */
  readonly mfaRequise: boolean;
}

export const CLE_ARCHIVES = ['archives'] as const;

export const archivesApi = {
  lister: () => api.get<{ archives: readonly ArchivePresentee[] }>('/archives'),
  /** L'archive et la version que désigne le lien (jeton dans le corps). */
  resoudreLien: (jeton: string) =>
    api.post<{ id: string; sha256: string }>('/archives/lien', { jeton }),
  accuser: (id: string, sha256: string) =>
    api.post<{ id: string; sha256: string }>(`/archives/${encodeURIComponent(id)}/accuse`, {
      sha256,
    }),
};

/**
 * Chemin de téléchargement d'un lien nominatif (même origine, cookie de
 * session) : composé par le client, seul à écrire les chemins de l'API.
 */
export function cheminTelechargement(jeton: string): string {
  return cheminLienArchive(jeton);
}

/**
 * Déclenche le téléchargement par le NAVIGATEUR (lien `download`) : l'archive
 * peut peser plusieurs gigaoctets, elle ne transite pas par la mémoire de la
 * page. Isolé ici pour que les tests le remplacent.
 */
export function lancerTelechargement(chemin: string): void {
  const lien = document.createElement('a');
  lien.href = chemin;
  lien.rel = 'noreferrer';
  lien.download = '';
  document.body.append(lien);
  lien.click();
  lien.remove();
}
